import { CommonModule, DOCUMENT, isPlatformBrowser, NgOptimizedImage } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, Input, NgZone, OnInit, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink } from '@angular/router';
import { CheckboxInputComponent } from '@app/_components/inputs/checkbox-input/checkbox-input.component';
import { RangeInputComponent } from '@app/_components/inputs/range-input/range-input.component';
import { SelectButtonComponent } from '@app/_components/inputs/select-button/select-button.component';
import { SelectInputComponent } from '@app/_components/inputs/select-input/select-input.component';
import { SelectSearchComponent } from '@app/_components/inputs/select-search/select-search.component';
import { TextInputComponent } from '@app/_components/inputs/text-input/text-input.component';
import { FormDataHelper, TranslateHelper } from '@app/_helpers';
import { AdvancedSearchService } from '@app/_services';
import { DirectionService } from '@app/_services/direction.service';
import { SharedService } from '@app/_services/shared.service';
import { CurrencyFormatPipe } from '@app/shared/pipes/currency-format.pipe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { fromEvent, of, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { CurrencyConvertPipe } from '@app/shared/pipes';
@UntilDestroy()
@Component({
    selector: 'app-block-advanced-search',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        SelectInputComponent,
        SelectSearchComponent,
        RangeInputComponent,
        TextInputComponent,
        CheckboxInputComponent,
        SelectButtonComponent,
        CurrencyFormatPipe,
        RouterLink,
        MatIconModule,
        NgOptimizedImage,
        CurrencyConvertPipe

    ],
    providers: [
        TranslateHelper
    ],
    templateUrl: './block-advanced-search.component.html',
    styleUrl: './block-advanced-search.component.scss'
})
export class BlockAdvancedSearchComponent implements OnInit, AfterViewInit {
    public activeTab: number = 0;

    @ViewChild('firstTab') firstTab: ElementRef<HTMLElement>;
    @ViewChild('searchFrom') searchFrom: ElementRef<HTMLElement>;
    active;
    products = [];
    realEstate = [];
    services = [];
    total = 0;
    landscapeImage = '/assets/images/landscape.jpg';
    public realestateForm = this.fb.group({
    });

    public productsForm = this.fb.group({
        searchText: [null],
    });

    public servicesForm = this.fb.group({
        searchText: [null],
    });
    get element(): HTMLElement { return this.elementRef.nativeElement; }

    constructor(
        @Inject(DOCUMENT) private document: Document,
        @Inject(PLATFORM_ID) private platformId: Object,
        private fb: UntypedFormBuilder,
        private router: Router,
        private advancedSearchService: AdvancedSearchService,
        private sharedService: SharedService,
        public translateHelper: TranslateHelper,
        public translateService: TranslateService,
        private direction: DirectionService,
        private zone: NgZone,
        private elementRef: ElementRef,
        private formDataHelper: FormDataHelper,
    ) {

    }
    ngAfterViewInit(): void {
        fromEvent(this.document, 'click').pipe(
            untilDestroyed(this),
        ).subscribe(event => {
            const activeElement = this.document.activeElement;
            if (activeElement && activeElement.closest('.search-forms') === this.searchFrom.nativeElement) {
                return;
            }
            if (event.target instanceof HTMLElement && this.searchFrom.nativeElement !== event.target.closest('.search-forms')) {
                this.zone.run(() => this.active = false);
            }
        });

        this.zone.runOutsideAngular(() => {
            fromEvent(this.searchFrom.nativeElement, 'focusout').pipe(
                debounceTime(10),
                untilDestroyed(this),
            ).subscribe(() => {
                if (this.document.activeElement === this.document.body) {
                    return;
                }
                if (this.document.activeElement && this.document.activeElement.closest('.search-forms') !== this.searchFrom.nativeElement) {
                    this.zone.run(() => this.active = false);
                }
            });
        });
    }

    ngOnInit(): void {
        this.buildForm();
        this.setLandscapeImage();

        this.searchInfo.data = _.sortBy(this.searchInfo?.data, function (property) {
            return ['Area', 'Property Type', 'Type'].indexOf(property.name.en)
        });
        this.productsForm.get('searchText').valueChanges.pipe(untilDestroyed(this), debounceTime(600), distinctUntilChanged(),
            switchMap(query => {
                if (!query) return of({})
                return this.advancedSearchService.getQuickSearchResult(query, 'p');
            })).subscribe(results => {
                this.products = results.products || [];
                this.total = results.total || 0;
                this.active = this.products?.length ? true : false;
            });

        // Subscribe to country changes to update landscape image
        this.sharedService.currentCountry$.pipe(untilDestroyed(this)).subscribe(() => {
            this.setLandscapeImage();
        });
    }

    search() {
        switch (this.activeTab) {
            case 0:
                this.searchProducts()
                break;
            case 1:
                this.searchRealestate()
                break;
            /*     case 2:
                    this.searchServices()
                    break; */
            default:
                break;
        }
    }


    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    buildForm() {
        this.realestateForm = this.fb.group({
        });
        _.forEach(this.searchInfo?.data, property => {
            let control: any = this.fb.control(null);
            this.realestateForm.addControl(
                property?.name.en, control
            );
        });
    }

    @Input() searchInfo;
    @Input() blockId;
    @Input() type;
    @Input() subtypeId;
    @Input() companyId;
    categoryIds;
    priceForm = this.fb.group({
        min: null,
        max: null
    })
    private destroy$: Subject<void> = new Subject();
    sector;
    form;
    icon = 'add';
    formObservable$: any;
    formValues;
    isRtl = this.direction.isRTL();
    currentWidth = 12;

    public changeTab(tab: number) {
        if (tab == this.activeTab) {
            return;
        }
        this.active = false;
        let offset: number = tab * 100;
        this.firstTab.nativeElement.style['margin-inline-start'] = `-${offset}%`;
        this.activeTab = tab;
    }

    public searchRealestate() {
        let params: any = {
            searchType: 'r',
            f: this.realestateForm.value,
        };

        params = this.formDataHelper.toQueryData(params);
        if (params) {
            this.router.navigate(
                ['/search'],
                {
                    queryParams: params,
                    queryParamsHandling: '',
                });
        }
        return params;
    }

    public searchProducts() {
        this.router.navigate(
            ['/search'],
            {
                queryParams: { q: this.productsForm.get('searchText').value, searchType: 'p' },
                queryParamsHandling: '',
            });
    }

    public searchServices() {
        this.router.navigate(
            ['/search'],
            {
                queryParams: { q: this.servicesForm.get('searchText').value, searchType: 's' },
                queryParamsHandling: '',
            });
    }

    public openForm(form) {
        switch (this.activeTab) {
            case 0:
                if (form.get('searchText').value && this.products.length) {
                    this.active = true;
                }
                break;
            /*       case 2:
                      this.searchServices()
                      break; */
            default:
                break;
        }


    }

    private setLandscapeImage(): void {
        const selectedCountry = this.sharedService.selectedCountry;
        
        if (!selectedCountry || !selectedCountry.code) {
            this.landscapeImage = '/assets/images/landscape.jpg';
            return;
        }

        const countryCode = selectedCountry.code;
        const countrySpecificImage = `/assets/images/${countryCode}_landscape.jpg`;
        
        // Only check image existence on browser (Image API not available in SSR)
        if (isPlatformBrowser(this.platformId)) {
            const img = new Image();
            img.onload = () => {
                this.landscapeImage = countrySpecificImage;
            };
            img.onerror = () => {
                // Fallback to default if image doesn't exist
                this.landscapeImage = '/assets/images/landscape.jpg';
            };
            img.src = countrySpecificImage;
        } else {
            // On server, use default image (will be updated on client)
            this.landscapeImage = '/assets/images/landscape.jpg';
        }
    }
}
